/**
 * Laravel + Bootstrap 4 Application JavaScript
 */

// Import jQuery and make it global FIRST (before anything else)
import $ from 'jquery';
window.jQuery = window.$ = $;

// Ensure jQuery is globally available before any plugins
if (typeof window.jQuery === 'undefined') {
    throw new Error('jQuery is required');
}

// Import Popper.js (required by Bootstrap 4)
import Popper from 'popper.js';
window.Popper = Popper;

// Import Bootstrap 4
import 'bootstrap';

// Import Slick Carousel CSS (must be imported before JS)
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Import Slick Carousel - this attaches to jQuery
import 'slick-carousel/slick/slick';

// Import Ekko Lightbox CSS
import 'ekko-lightbox/dist/ekko-lightbox.css';

// Import Laravel's default bootstrap (axios, etc.) - AFTER jQuery
import './laravel-bootstrap';

// Import custom template JavaScript - LAST (needs jQuery)
import './template';

// Altcha CAPTCHA web component (self-registers as <altcha-widget>)
// English is bundled by default; register the German i18n so the widget can
// localize its labels (selected via the `language` attribute / <html lang>).
import 'altcha';
import 'altcha/i18n/de';

// Download & press area gallery modal (no jQuery dependency)
import './downloads';

// Dynamically import ekko-lightbox AFTER everything else to ensure jQuery is available
// This fixes the "jQuery is not defined" error in ekko-lightbox
(function() {
    const loadEkkoLightbox = async () => {
        try {
            await import('ekko-lightbox/dist/ekko-lightbox');
            console.log('Ekko Lightbox loaded successfully');
        } catch (error) {
            console.error('Failed to load Ekko Lightbox:', error);
        }
    };

    // Load when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loadEkkoLightbox);
    } else {
        loadEkkoLightbox();
    }
})();
